// Marca del hotel (multi-hotel) — fuente única de verdad en el frontend.
// Vue CLI hornea las VUE_APP_* en build; si no se definen, el default es Mansión.
// Para cambiar de hotel: definir VUE_APP_BRAND_* en el .env del despliegue.
const env = process.env;

// Carpeta de logos del hotel. VUE_APP_BRAND_LOGO_DIR selecciona:
//   - public/img/<dir>/logo.png        (logo impreso en tickets/comandas)
//   - src/assets/imagenes/<dir>/*.webp (logos de login/sidebar — ver AppLogo.vue)
const logoDir = env.VUE_APP_BRAND_LOGO_DIR || 'mansion';

// Multiplicador de tamaño del logo en impresiones (comandas). Default 1
// = comportamiento actual sin cambios. Solo se activa vía .env por hotel.
const logoEscala = parseFloat(env.VUE_APP_BRAND_LOGO_ESCALA) || 1;

export const BRAND = {
  logoDir,
  logoEscala,
  nombre:      env.VUE_APP_BRAND_NOMBRE       || 'Hotel Mansión del Viajero',
  nombreCorto: env.VUE_APP_BRAND_NOMBRE_CORTO || 'Hotel Mansión',
  nit:         env.VUE_APP_BRAND_NIT          || '598083-6',
  direccion:   env.VUE_APP_BRAND_DIRECCION    || '7 AVENIDA "A", 18-20, LAS ROSAS, ZONA 5',
  telefono:    env.VUE_APP_BRAND_TELEFONO     || '',
  logo:        env.VUE_APP_BRAND_LOGO         || `/img/${logoDir}/logo.png`,
};

export default BRAND;
